/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Error_Username_RequiredInputs */

const vi_smartlab_irrigation_error_username_required = /** @type {(inputs: Smartlab_Irrigation_Error_Username_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tên đăng nhập API tưới`)
};

/**

* @param {Smartlab_Irrigation_Error_Username_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_error_username_required = /** @type {((inputs?: Smartlab_Irrigation_Error_Username_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Error_Username_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_error_username_required(inputs)
});